/* eslint-disable @typescript-eslint/no-unused-vars */
import { AddressSearch } from "@flick/plan_chooser";
import { ROUTES } from "domain/configuration";
import { createFlickSignUpAction } from "domain/core/actions";
import { selectAddress, setCurrentFormStep } from "domain/core/reducers";
import { AddressType } from "domain/core/types";
import { sendAnalyticsPageView } from "lib/util";
import React, { useCallback, useEffect } from "react";
import { useNavigate } from "react-router";
import { useAppDispatch } from "store/storeHooks";

export function Address() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleOnConfirmAddress = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (supplyNode: any, address: AddressType) => {
      if (supplyNode || address) {
        const populatedAddress = supplyNode?.address || address;
        const supplyNodeAddress = {
          ...populatedAddress,
          unit: populatedAddress.unitIdentifier,
          icp: supplyNode?.icpNumber,
        };
        dispatch(
          selectAddress({
            address: supplyNodeAddress,
            eligibility: supplyNode?.shortEligibilityReason(),
          }),
        );
        dispatch(createFlickSignUpAction.request());
        dispatch(setCurrentFormStep(ROUTES.details));
        navigate(ROUTES.details);
      }
    },
    [],
  );

  useEffect(() => {
    sendAnalyticsPageView("/join");
  }, []);

  return (
    <section className="join_address">
      <AddressSearch
        addressFinderKey={process.env.REACT_APP_ADDRESS_FINDER_KEY}
        apiBaseUrl={process.env.REACT_APP_FLICK_API_ENDPOINT}
        continueJoiningCallback={handleOnConfirmAddress}
      />
      <div className="text_block avoid_margin_collapse">
        <h3>Let's see if we have a connection...</h3>
        <p className="join_paragraph--narrow">
          Haere mai, e hoa - it takes just 3 minutes to join the only power
          company that checks you're on the right plan for your usage every 90
          days.
        </p>
        <p className="join_paragraph--narrow">
          Our Flickin' Best Plan Promise also won the Best Energy Innovation at
          the NZ Compare Awards 2022 – just saying.
        </p>
      </div>
    </section>
  );
}

export default Address;
